import React from 'react';

export default function Maintenance({className, msg}) {
  const msgHtml = msg ? msg.replace(/\\n/, '<br/>') : '';

  return (
    <div className={className}>
      <div className="inner_box" style={{
        display: 'table',
        width: '100%',
        height: '100%'
      }}>
        <p className="desc_g" style={{
          display: 'table-cell',
          verticalAlign: 'middle'
        }} dangerouslySetInnerHTML={{__html: msgHtml}}></p>
      </div>
    </div>
  );
}
